export default {"src":"/_next/static/media/logo-shab.be72ce53.svg","height":41,"width":124,"blurWidth":0,"blurHeight":0};